import React from "react";
import styled from "@emotion/styled";
import UserImage from "@components/item/UserImage";
import FollowButton from "@components/button/FollowButton";
import SwiperContainer from "@components/swiper/SwiperContainer";
import Image from "@components/item/Image";
import { SwiperSlide } from "swiper/react";
import { useNavigate } from "react-router-dom";

const Container = styled.div({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  gap: "0.4rem",
});

const InfoContainer = styled.div({
  display: "flex",
  justifyContent: "space-between",
  gap: "0.4rem",
  alignItems: "center",
});

const LeftSide = styled.div(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "1.6rem",
  fontSize: "1.6rem",
  fontWeight: theme.fontWeight.medium,
  lineHeight: "2rem",
}));

const ImageWrapper = styled(SwiperSlide)(({ theme }) => ({
  display: "flex",
}));

type Props = {
  id: number;
  name: string;
  follow: boolean;
  src: string;
  is_me?: boolean;
  withImage?: boolean;
  imageList?: any[];
};
const SellerCard = ({
  id,
  name,
  follow,
  src,
  is_me,
  withImage,
  imageList,
}: Props) => {
  const navigate = useNavigate();
  const handleNavigateProductDetail = (productId: number) => {
    navigate(`/product-detail/${productId}`);
  };

  const handleNavigateSellerDetail = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    navigate(`/seller/${id}`);
  };

  return (
    <Container>
      <InfoContainer onClick={handleNavigateSellerDetail}>
        <LeftSide>
          <UserImage size="6rem" src={src} />
          <span>{name}</span>
        </LeftSide>

        {!is_me && <FollowButton isFollow={follow} id={id} />}
      </InfoContainer>

      {withImage && (
        <SwiperContainer space={8}>
          {imageList?.map((item, index) => (
            <ImageWrapper
              key={index}
              onClick={() => handleNavigateProductDetail(item.product_id)}>
              <Image src={item.thumbnail_url} width="18rem" height="11.6rem" />
            </ImageWrapper>
          ))}
        </SwiperContainer>
      )}
    </Container>
  );
};

export default SellerCard;
